import React from "react";
import CodeEditorMock from "../Panels/CodeEditorMock";
import autoSeoImg1 from "../../assets/images/autoseo2.jpg";
import autoSeoImg2 from "../../assets/images/autoseo3.jpg";

import seoAssistantImg from "../../assets/images/seoassistant2.jpg";
const AutoSEO = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          autoSEO
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content single-project">
        <div className="left">
          <CodeEditorMock>
            This is a{" "}
            <span class="function-color op-1">WordPress plugin project</span> I
            built called <span class="string-color-text op-1">AutoSEO</span>,
            designed to boost on-page SEO through smart AI-powered suggestions.
            It works by scanning an entire page's content and returning{" "}
            <span class="return-color op-1">tailored meta titles</span>,{" "}
            <span class="return-color op-1">descriptions</span>, and{" "}
            <span class="return-color op-1">slugs</span> that can help increase
            SEO performance.
            <br />
            <br />
            The backend is powered by{" "}
            <span class="nodejs-color-text op-1">Node.js</span> and uses the{" "}
            <span class="docker-color-text op-1">Gemini API</span> for all AI
            functionality, while the plugin itself is built with{" "}
            <span class="html-color-text op-1">PHP</span> to run natively inside{" "}
            <span class="wordpress-color-text op-1">WordPress</span>. It
            communicates directly with the backend for every content analysis
            request.
            <br />
            <br />
            Users are shown dynamic, context-aware suggestions directly inside
            their post and page editors. The goal is to make SEO easy and fast
            for content creators, even without technical knowledge.
            <br />
            <br />
            The project is currently in development and deployed at{" "}
            <span class="string-color-text op-1">seoassistant.nl</span>, where
            full product access will be available soon.
          </CodeEditorMock>
        </div>
        <div className="right">
          <p className="comment">// Features of the product</p>
          <img src={autoSeoImg1} alt="" />
          <p className="comment">// Landing of product's website</p>
          <img src={autoSeoImg2} alt="" />
          <p className="comment">// Code snippet of adding meta tags to html</p>
          <div className="box-container">
            <CodeEditorMock>
              <span class="keyword-color">add_action</span>
              <span class="paren-color">(</span>
              <span class="string-color">'wp_head'</span>,{" "}
              <span class="string-color">'autoseo_add_meta_tags'</span>
              <span class="paren-color">)</span>;
              <br />
              <span class="keyword-color">function</span>{" "}
              <span class="function-color">autoseo_add_meta_tags</span>()
              <span class="brace-color">{"{"}</span>
              <br />
              &nbsp;&nbsp;<span class="keyword-color">if</span>{" "}
              <span class="paren-color">(</span>
              <span class="function-color">is_singular</span>()
              <span class="paren-color">)</span>{" "}
              <span class="brace-color">{"{"}</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="keyword-color">
                global
              </span>{" "}
              <span class="variable-color">$post</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">$description</span> ={" "}
              <span class="function-color">get_post_meta</span>(
              <span class="variable-color">$post</span>
              <span class="operator-color">-&gt;</span>ID,
              <span class="string-color">'_autoseo_description'</span>,{" "}
              <span class="keyword-color">true</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">$keyphrase</span> ={" "}
              <span class="function-color">get_post_meta</span>(
              <span class="variable-color">$post</span>
              <span class="operator-color">-&gt;</span>ID,
              <span class="string-color">'_autoseo_keyphrase'</span>,{" "}
              <span class="keyword-color">true</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">$noindex</span> ={" "}
              <span class="function-color">get_post_meta</span>(
              <span class="variable-color">$post</span>
              <span class="operator-color">-&gt;</span>ID,
              <span class="string-color">'_autoseo_noindex'</span>,{" "}
              <span class="keyword-color">true</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">$robots_content</span> = (
              <span class="variable-color">$noindex</span> ==={" "}
              <span class="string-color">'1'</span>) ?{" "}
              <span class="string-color">'noindex, nofollow'</span> :{" "}
              <span class="string-color">'index, follow'</span>;
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="variable-color">
                $title
              </span>{" "}
              = <span class="function-color">get_the_title</span>(
              <span class="variable-color">$post</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="variable-color">
                $url
              </span> = <span class="function-color">get_permalink</span>(
              <span class="variable-color">$post</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="variable-color">
                $image
              </span>{" "}
              = <span class="function-color">get_the_post_thumbnail_url</span>(
              <span class="variable-color">$post</span>,{" "}
              <span class="string-color">'full'</span>);
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="comment-color">
                // Fallback image if no featured image is set
              </span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="keyword-color">if</span> (
              <span class="operator-color">!</span>
              <span class="variable-color">$image</span>){" "}
              <span class="brace-color">{"{"}</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="variable-color">$image</span> ={" "}
              <span class="function-color">plugin_dir_url</span>(
              <span class="constant-color">__FILE__</span>) +{" "}
              <span class="string-color">'default-og-image.jpg'</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="brace-color">{"}"}</span>
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta name="robots" content="'
              </span>{" "}
              . <span class="function-color">esc_attr</span>(
              <span class="variable-color">$robots_content</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="keyword-color">if</span> (
              <span class="variable-color">$description</span>){" "}
              <span class="brace-color">{"{"}</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color">echo</span>{" "}
              <span class="string-color">
                '&lt;meta name="description" content="'
              </span>{" "}
              . <span class="function-color">esc_attr</span>(
              <span class="variable-color">$description</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="brace-color">{"}"}</span>
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="keyword-color">if</span> (
              <span class="variable-color">$keyphrase</span>){" "}
              <span class="brace-color">{"{"}</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color">echo</span>{" "}
              <span class="string-color">
                '&lt;meta name="keywords" content="'
              </span>{" "}
              . <span class="function-color">esc_attr</span>(
              <span class="variable-color">$keyphrase</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="brace-color">{"}"}</span>
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="comment-color">// Open Graph tags</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta property="og:title" content="'
              </span>{" "}
              . <span class="function-color">esc_attr</span>(
              <span class="variable-color">$title</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta property="og:description" content="'
              </span>{" "}
              . <span class="function-color">esc_attr</span>(
              <span class="variable-color">$description</span> ?:{" "}
              <span class="variable-color">$title</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta property="og:type" content="article"&gt;
              </span>{" "}
              . <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta property="og:url" content="'
              </span>{" "}
              . <span class="function-color">esc_url</span>(
              <span class="variable-color">$url</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta property="og:image" content="'
              </span>{" "}
              . <span class="function-color">esc_url</span>(
              <span class="variable-color">$image</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="comment-color">// Twitter Card (optional)</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta name="twitter:card" content="summary_large_image"&gt;
              </span>{" "}
              . <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta name="twitter:title" content="'
              </span>{" "}
              . <span class="function-color">esc_attr</span>(
              <span class="variable-color">$title</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta name="twitter:description" content="'
              </span>{" "}
              . <span class="function-color">esc_attr</span>(
              <span class="variable-color">$description</span> ?:{" "}
              <span class="variable-color">$title</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="function-color">
                echo
              </span>{" "}
              <span class="string-color">
                '&lt;meta name="twitter:image" content="'
              </span>{" "}
              . <span class="function-color">esc_url</span>(
              <span class="variable-color">$image</span>) .{" "}
              <span class="string-color">'"&gt;</span> .{" "}
              <span class="string-color">"\n"</span>;
              <br />
              &nbsp;&nbsp;<span class="brace-color">{"}"}</span>
              <br />
              <span class="brace-color">{"}"}</span>
            </CodeEditorMock>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoSEO;
